// ==============================
// HELPERS
// ==============================

function updateCSSVariables() {
  const h = window.innerHeight;
  const header = document.getElementById("header");
  const m = header ? header.offsetHeight : 0;

  document.documentElement.style.setProperty("--h", `${h}px`);
  document.documentElement.style.setProperty("--m", `${m}px`);
}

function easeInOutCubicBezier(t) {
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

function smoothScrollTo(targetY, duration = 600) {
  const startY = window.scrollY;
  const distance = targetY - startY;
  const startTime = performance.now();

  function animation(currentTime) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const easedProgress = easeInOutCubicBezier(progress);

    window.scrollTo(0, startY + distance * easedProgress);

    if (progress < 1) {
      requestAnimationFrame(animation);
    }
  }

  requestAnimationFrame(animation);
}

// ==============================
// LAZY LOAD
// ==============================

let lazyObserver = null;

function initLazyObserver() {
  if (!("IntersectionObserver" in window)) return;

  lazyObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const img = entry.target;

      if (img.dataset.src) {
        img.src = img.dataset.src;
      }

      img.classList.remove("lazy");
      lazyObserver.unobserve(img);
    });
  });
}

function observeLazyImages() {
  if (!lazyObserver) return;

  document.querySelectorAll("img.lazy").forEach((img) => {
    lazyObserver.observe(img);
  });
}

// ==============================
// IMAGE ORIENTATION
// ==============================
function setImageOrientationClasses() {
  $("img").each(function () {
    const img = this;

    function applyClass() {
      const width = img.naturalWidth;
      const height = img.naturalHeight;

      $(img).removeClass("portrait landscape square");

      const difference = Math.abs(width - height) / Math.max(width, height);

      if (difference <= 0.05) {
        // 5%
        $(img).addClass("square");
      } else if (height > width) {
        $(img).addClass("portrait");
      } else {
        $(img).addClass("landscape");
      }
    }

    if (img.complete) {
      applyClass();
    } else {
      $(img).one("load", applyClass);
    }
  });
}
function truncateTitle(el) {
  const fullTitle = el.dataset.title;

  if (!fullTitle) return;

  el.textContent = fullTitle;

  // El elemento todavía no tiene dimensiones.
  if (el.clientWidth === 0) return;

  if (el.scrollWidth <= el.clientWidth) return;

  let text = fullTitle;
  const dots = "\u00A0...";

  while (text.length > 0) {
    text = text.slice(0, -1);

    el.textContent = text.trimEnd() + dots;

    if (el.scrollWidth <= el.clientWidth) {
      break;
    }
  }
}

function truncateTitles(container = document) {
  container.querySelectorAll(".metafield-value.truncate").forEach(truncateTitle);
}

function initTitleTruncate() {
  const observedElements = new WeakSet();

  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      truncateTitle(entry.target);
    }
  });

  function observeTitles(container = document) {
    const elements = container.querySelectorAll(".metafield-value.truncate");

    elements.forEach((el) => {
      if (observedElements.has(el)) return;

      observedElements.add(el);
      resizeObserver.observe(el);
      truncateTitle(el);
    });
  }

  function runInitialTruncate() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        observeTitles();
        truncateTitles();
      });
    });
  }

  // Espera a que la fuente tenga sus medidas definitivas.
  if (document.fonts?.ready) {
    document.fonts.ready.then(runInitialTruncate);
  } else {
    runInitialTruncate();
  }

  // Detecta productos añadidos por fetch/AJAX.
  const mutationObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches(".metafield-value.truncate")) {
          observeTitles(node.parentElement || document);
          return;
        }

        observeTitles(node);
      });
    }
  });

  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

document.addEventListener("DOMContentLoaded", initTitleTruncate);

document.addEventListener("DOMContentLoaded", () => {
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(initTitleTruncate);
  } else {
    window.addEventListener("load", initTitleTruncate);
  }
});

let truncateTimer;

window.addEventListener("resize", () => {
  clearTimeout(truncateTimer);
  truncateTimer = setTimeout(truncateTitles, 100);
});
// ==============================
// MOBILE / TOUCH
// ==============================
$(document).on("click", ".read-more", function () {
  $("#main-product .thumbnail").toggleClass("active");
  $(".product-gallery-embla").toggleClass("active");
  $(".buy-block").toggleClass("active");
});

// ==============================
// MOBILE / TOUCH
// ==============================

function cancelHoverOnMobile() {
  if (!window.matchMedia("(hover: none)").matches) return;

  document.querySelectorAll(".has-hover").forEach((el) => {
    el.addEventListener("touchstart", () => {
      el.classList.remove("is-hover");
    });
  });
}

// ==============================
// LENIS / INTRO
// ==============================
let lenis;

function initLenisIntro() {
  // Limpiar timeout anterior si existe
  if (window.introTimeout) {
    clearTimeout(window.introTimeout);
    window.introTimeout = null;
  }

  const isHome = document.body.classList.contains("template-index");
  const isProduct = document.body.classList.contains("template-product");
  const isLockedPage = isHome || isProduct;
  const isMobile = window.innerWidth <= 768;

  let introFinished = false;

  // Inicializar Lenis
  lenis = new Lenis({
    lerp: 0.1,
    smoothWheel: true,
    smoothTouch: true,
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);

  // Evitar que el navegador restaure el scroll
  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }

  // Solo envolver el contenido en páginas con intro
  if (isLockedPage && $(".intro").length && !$(".page-content").length) {
    $(".header").nextAll().addBack().wrapAll('<div class="page-content"></div>');
  }

  // Si no estamos en home/product o no existe intro, iniciar Lenis normalmente
  if (!isLockedPage || !$(".intro").length) {
    lenis.start();
    return;
  }

  const $intro = $(".intro");

  /*
   * En la home móvil, la intro normal pasa a ser individual.
   *
   * Home desktop:
   * .intro → solo clic
   *
   * Home móvil:
   * .intro.individual → automático + clic
   *
   * Product:
   * Si ya tiene .individual → automático + clic
   * Si no tiene .individual → solo clic
   */
  if (isHome && isMobile) {
    $intro.addClass("individual");
  }

  // Bloquear scroll mientras la intro está visible
  lenis.stop();
  window.scrollTo(0, 0);

  document.body.classList.add("intro-locked");

  document.documentElement.style.overflow = "hidden";
  document.body.style.overflow = "hidden";
  document.body.style.touchAction = "none";

  function closeIntro() {
    // Evitar que la función se ejecute dos veces
    if (introFinished) return;

    introFinished = true;

    // Cancelar cierre automático si se cierra mediante clic
    if (window.introTimeout) {
      clearTimeout(window.introTimeout);
      window.introTimeout = null;
    }

    window.scrollTo(0, 0);
    lenis.scrollTo(0, {
      immediate: true,
    });

    requestAnimationFrame(() => {
      document.body.classList.add("intro-transitioning");

      setTimeout(() => {
        $intro.remove();

        document.body.classList.remove("intro-locked", "intro-transitioning");

        document.documentElement.style.overflow = "";
        document.body.style.overflow = "";
        document.body.style.touchAction = "";

        lenis.resize();
        lenis.start();
      }, 520);
    });
  }

  // Solo las intros con la clase .individual se cierran automáticamente
  if ($intro.hasClass("individual")) {
    window.introTimeout = setTimeout(() => {
      closeIntro();
    }, 2300);
  }

  // Todas las intros se pueden cerrar haciendo clic
  $intro.off("click.intro").on("click.intro", function () {
    closeIntro();
  });
}
// ==============================
// EVENTS
// ==============================

document.addEventListener("DOMContentLoaded", () => {
  updateCSSVariables();

  initLazyObserver();
  observeLazyImages();

  setImageOrientationClasses();
  cancelHoverOnMobile();
  initLenisIntro();

  // Mobile description
  $(".new-top .toggle-btn").on("click", function () {
    $(".product-meta-block.secondary").stop(true, true).slideToggle(300);
  });

  // Toggle text
  $(".toggle-btn").on("click", function () {
    const $btn = $(this);
    const $article = $btn.closest("article");
    const $content = $article.find(".toggle-content");

    if (!$btn.data("original-text")) {
      $btn.data("original-text", $btn.text());
    }

    const originalText = $btn.data("original-text");

    $content.slideToggle(200);

    if ($btn.hasClass("is-open")) {
      $btn.text(originalText).removeClass("is-open");
    } else {
      $btn.text("CLOSE").addClass("is-open");
    }
  });

  // Menu open
  $(".menu-open").on("click", function (e) {
    e.stopPropagation();

    const isActive = $(".menu-pop-up").toggleClass("active").hasClass("active");

    $(this).text(isActive ? "close" : "menu");

    $(".main, #products").toggleClass("no-pointer", isActive);

    $("body").toggleClass("no-scroll", isActive);
  });

  $(".menu-pop-up").on("click", function (e) {
    e.stopPropagation();
  });

  $(document).on("click", function () {
    $(".menu-pop-up").removeClass("active");
    $(".menu-open").text("menu");
    $(".main, #products").removeClass("no-pointer");
  });

  // Mobile search
  document.addEventListener("click", function (e) {
    const link = e.target.closest(".movil-search a");
    if (!link) return;

    e.preventDefault();
    e.stopPropagation();

    const search = document.querySelector(".archive-search");
    if (!search) return;

    const isActive = search.classList.toggle("active");

    document.body.classList.toggle("no-scroll", isActive);
    link.textContent = isActive ? "CLOSE" : "SEARCH";
  });

  // More books
  document.querySelectorAll(".more, .more-movil").forEach((moreBtn) => {
    moreBtn.addEventListener("click", () => {
      const related = document.querySelector("#related");
      if (!related) return;

      const top = related.offsetTop - (window.innerHeight - related.offsetHeight) + 10;

      smoothScrollTo(top, 600);
    });
  });
  // More Info
  document.querySelectorAll(".info-book").forEach((moreBtn) => {
    moreBtn.addEventListener("click", () => {
      const related = document.querySelector(".info-new");
      if (!related) return;

      const top = related.offsetTop - (window.innerHeight - related.offsetHeight) + 10;

      smoothScrollTo(top, 600);
    });
  });

  // Info toggle
  $(".toggle-btn").on("click", function () {
    const $block = $(this).closest(".toggle-block");
    const $icon = $(this).find(".icon");

    $block.toggleClass("active");
    $block.find(".toggle-content").slideToggle(200);

    $icon.text($block.hasClass("active") ? "–" : "+");
  });

  // Footer observer for mobile search
  const movilSearch = document.querySelector(".movil-search");
  const footer = document.querySelector("footer");

  if (movilSearch && footer && "IntersectionObserver" in window) {
    const footerObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          movilSearch.classList.toggle("active", entry.isIntersecting);
        });
      },
      {
        root: null,
        threshold: 0,
      },
    );

    footerObserver.observe(footer);
  }
});

// ==============================
// RESIZE
// ==============================

window.addEventListener("resize", updateCSSVariables);
